import { LocalParticipant, type Participant } from "livekit-client";
import { PARTICIPANT_ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { ParticipantRole } from "@circle-react/types/Live/Participant";
import type { Peer } from "@circle-react/types/Live/Peer";
import type { ParticipantMetadata } from "../types";

export const ACTION_TYPES = Object.freeze({
  PUBLISH_METADATA: "PUBLISH_METADATA",
  UPDATE_ROOM: "UPDATE_ROOM",
  MUTE_MICROPHONE: "MUTE_MICROPHONE",
  DISABLE_CAMERA: "DISABLE_CAMERA",
  LOWER_HAND: "LOWER_HAND",
});

export type ActionType = keyof typeof ACTION_TYPES;

export const sendSignal = (
  type: ActionType,
  localParticipant: LocalParticipant,
  targetParticipantId: string,
) => {
  if (targetParticipantId && localParticipant) {
    const message = { type };
    const encodedMessage = new TextEncoder().encode(JSON.stringify(message));
    return localParticipant.publishData(encodedMessage, {
      reliable: true,
      destinationIdentities: [targetParticipantId],
    });
  }
  return Promise.resolve();
};

export const parseParticipantMetadata = (
  participant: Participant,
): ParticipantMetadata => {
  try {
    return JSON.parse(participant.metadata || "{}") as ParticipantMetadata;
  } catch (e: any) {
    console.error("Could not parse participant metadata: ", e.message);
    return {};
  }
};

export const convertParticipantToPeer = (participant: Participant): Peer => {
  const metadata = parseParticipantMetadata(participant);
  const roleName: ParticipantRole =
    metadata.role || PARTICIPANT_ROLES.HLS_SPECTATOR;
  const customerUserId = metadata.user_id;
  return {
    ...participant,
    id: participant.identity,
    name: participant.name || participant.identity,
    customerUserId,
    roleName,
    isHandRaised: metadata.isHandRaised || false,
    isLocal: participant instanceof LocalParticipant,
    auxiliaryTracks: [],
  };
};
